import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GsDropdownMenuItem } from 'libs/shared/src';
import { GsIconComponent, GsOptimizedImageComponent } from 'libs/shared/src/components';
import { DropdownStyleBase } from '../dropdown/dropdown-style-base';

@Component({
  selector: 'megamenu',
  standalone: true,
  imports: [CommonModule, GsOptimizedImageComponent, GsIconComponent],
  templateUrl: './megamenu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class MegaMenuComponent extends DropdownStyleBase {
  // Methods
  /**
   * Generates a unique tracking identifier for a mega menu item.
   * @param item - The menu item of type `GsDropdownMenuItem`.
   * @returns A concatenated string consisting of the item's label, ID, and link URL.
   */
  trackMegaMenu(item: GsDropdownMenuItem): string {
    return item.label + item.iD + item.linkUrl;
  }
}
